export const button3DSx = {
    textTransform: 'none',
    borderRadius: 2,
    px: 2,
    py: 0.7,
    fontSize: '0.8rem',
    fontWeight: 600,
    boxShadow: '0 2px 0 0 rgba(0,0,0,0.15), 0 4px 8px rgba(0,0,0,0.1)',
    borderBottom: '2px solid rgba(0,0,0,0.15)',
    '&:hover': {
        boxShadow: '0 1px 0 0 rgba(0,0,0,0.15), 0 2px 4px rgba(0,0,0,0.1)',
        transform: 'translateY(1px)',
    },
    '&:active': {
        boxShadow: 'none',
        transform: 'translateY(2px)',
    },
    transition: 'all 0.1s ease',
};
